/**
 * MCP read-model 진입점. 웹뷰 브리지(`mcp-bridge.ts`)가 부르고, bun:test가 같은 함수를 검증한다.
 *
 * 결과는 `{ ok:true, data }` 또는 `{ ok:false, error:{ code, message } }`. 웹뷰가 돌려줄 수 있는 코드는
 * NOT_FOUND · INVALID_ARGUMENT · INTERNAL뿐이다(나머지는 Rust가 정한다).
 * 목록은 `truncated`를 data 안에 싣는다. Rust가 이를 `meta.truncated`로 올린다.
 */
import catalog from "../mcp-tools.json";
import { ToolFailure } from "./paging";
import { tools, type ToolOptions } from "./tools";
import type { McpSnapshot } from "./snapshot";

export type { McpSnapshot, McpWorkspace, EditorOverlay } from "./snapshot";
export { snapshotFromCatalog } from "./snapshot";
export { contextOf } from "./tools";
export type { ToolOptions } from "./tools";

export type ReadModelErrorCode = "NOT_FOUND" | "INVALID_ARGUMENT" | "INTERNAL";

export type ToolOutcome = { ok: true; data: unknown } | { ok: false; error: { code: ReadModelErrorCode; message: string } };

/** 웹뷰가 계산하는 도구 이름(카탈로그의 handler: webview). */
export const WEBVIEW_TOOLS: readonly string[] = catalog.tools.filter((t) => t.handler === "webview").map((t) => t.name);

export function runTool(tool: string, args: unknown, snap: McpSnapshot, opts: ToolOptions): ToolOutcome {
  const impl = (tools as Record<string, ((s: McpSnapshot, a: Record<string, unknown>, o: ToolOptions) => unknown) | undefined>)[tool];
  if (!impl || !WEBVIEW_TOOLS.includes(tool)) return { ok: false, error: { code: "INVALID_ARGUMENT", message: "tool: 알 수 없는 도구입니다" } };
  const a = args && typeof args === "object" && !Array.isArray(args) ? (args as Record<string, unknown>) : {};
  try {
    return { ok: true, data: impl(snap, a, opts) };
  } catch (e) {
    if (e instanceof ToolFailure) return { ok: false, error: { code: e.code, message: e.message } };
    return { ok: false, error: { code: "INTERNAL", message: "읽기 모델에서 오류가 났습니다" } };
  }
}
